import { ReduxRootState, RootState } from 'model/Redux';
import { Selector } from 'react-redux';
import IWithdrawsStoreData from './IWithdrawsStoreData';

export const withdrawsSelector: Selector<RootState, ReduxRootState<IWithdrawsStoreData[]>> = state => state.withdraws;
export const withdrawsDataSelector: Selector<RootState, IWithdrawsStoreData[]> = state => state.withdraws.data;